export const translateRole = (role: number) => {
  if (role === 0) return "Administrator";
  if (role === 1) return "Developer";
  if (role === 2) return "Reviewer";
  if (role === 3) return "Superadmin";
  return "Unknown Role";
};
